import React, { useEffect, useState } from "react";
import Modal from "../../../components/Modal";
import { publicUploadUrl } from "../../../utils/orientacaoProducaoImageUrl";

export type AssinaturaImagemVisualizacao = {
  titulo: string;
  imagem: string;
  nome?: string | null;
  data?: string | null;
};

function formatarDataAssinatura(iso?: string | null): string {
  if (!iso) return "";
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

type AssinaturaImagemModalProps = {
  visualizacao: AssinaturaImagemVisualizacao | null;
  onClose: () => void;
};

const AssinaturaImagemModal: React.FC<AssinaturaImagemModalProps> = ({
  visualizacao,
  onClose,
}) => {
  const [erro, setErro] = useState(false);
  const src = visualizacao?.imagem
    ? publicUploadUrl(visualizacao.imagem)
    : "";
  const descricao = [visualizacao?.nome, formatarDataAssinatura(visualizacao?.data)]
    .filter(Boolean)
    .join(" · ");

  useEffect(() => {
    setErro(false);
  }, [visualizacao?.imagem]);

  return (
    <Modal
      isOpen={visualizacao != null && Boolean(src)}
      onClose={onClose}
      title={visualizacao?.titulo ?? "Assinatura"}
      description={descricao || undefined}
      panelClassName="max-w-lg"
      bodyClassName="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4 sm:p-6"
      compactHeader
    >
      {erro ? (
        <p className="text-sm text-neutral-600">
          Não foi possível carregar a imagem desta assinatura.
        </p>
      ) : (
        <div className="rounded-xl border border-neutral-200 bg-neutral-50 p-4">
          <img
            src={src}
            alt={
              visualizacao?.nome
                ? `Assinatura de ${visualizacao.nome}`
                : "Imagem da assinatura"
            }
            className="mx-auto max-h-72 w-full object-contain"
            onError={() => setErro(true)}
          />
        </div>
      )}
    </Modal>
  );
};

export default AssinaturaImagemModal;
